var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"login"}},[_c('v-container',{attrs:{"tag":"section"}},[_c('v-layout',{staticClass:"mx-auto",staticStyle:{"max-width":"1200px"},attrs:{"align-center":"","justify-end":""}},[_c('LoginForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }